import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';



export default function UpgradePage() {
  const { profile, signOut } = useAuth();
  const navigate = useNavigate();

  const trialExpired = profile?.trial_ends_at && new Date(profile.trial_ends_at) < new Date();
  const neverHadTrial = !profile?.trial_ends_at;

  return (
    <div style={{ minHeight: '100vh', background: '#111009', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '24px 20px', position: 'relative', overflow: 'hidden' }}>
      <div className="bg-grid"/>
      <div style={{ position: 'absolute', width: 400, height: 400, borderRadius: '50%', background: 'radial-gradient(circle, rgba(255,85,0,0.07) 0%, transparent 70%)', top: -100, left: '50%', transform: 'translateX(-50%)', pointerEvents: 'none' }}/>

      <div style={{ width: '100%', maxWidth: 400, background: '#171410', border: '1px solid #2A2520', borderRadius: 20, padding: '36px 28px', position: 'relative', zIndex: 1, boxShadow: '0 24px 80px rgba(0,0,0,0.6)', textAlign: 'center' }}>

        <div style={{ marginBottom: 16 }}>
          <img src="/logo.png" alt="Drumnasium" style={{ width: 120, height: 120, objectFit: 'contain' }}/>
        </div>

        {trialExpired ? (
          <>
            <h2 style={{ fontFamily: "'Barlow Condensed'", fontSize: 28, fontWeight: 900, color: '#F0EBE3', letterSpacing: 2, marginBottom: 8 }}>TRIAL ENDED</h2>
            <p style={{ fontSize: 14, color: '#5A5650', lineHeight: 1.7, marginBottom: 28 }}>
              Your 30-day free trial has expired.<br/>
              Contact us at drumnasium.app@gmail.com to get full access.
            </p>
          </>
        ) : (
          <>
            <h2 style={{ fontFamily: "'Barlow Condensed'", fontSize: 28, fontWeight: 900, color: '#F0EBE3', letterSpacing: 2, marginBottom: 8 }}>ACCESS REQUIRED</h2>
            <p style={{ fontSize: 14, color: '#5A5650', lineHeight: 1.7, marginBottom: 28 }}>
              You need an active plan to use Drumnasium.<br/>
              Contact us at drumnasium.app@gmail.com to get access.
            </p>
          </>
        )}

        {/* What's available */}
        <div style={{ background: '#1C1916', borderRadius: 12, padding: '16px 18px', marginBottom: 24, textAlign: 'left' }}>
          <div style={{ fontFamily: "'Barlow Condensed'", fontSize: 11, fontWeight: 700, letterSpacing: 2, color: '#7A7268', marginBottom: 12 }}>AVAILABLE FOR FREE</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, color: '#F0EBE3', fontSize: 14 }}>
            <span style={{ fontSize: 20 }}>🎵</span>
            <div>
              <div style={{ fontWeight: 700 }}>Metronome</div>
              <div style={{ fontSize: 12, color: '#5A5650' }}>Tap tempo, rhythm trainer, time signatures</div>
            </div>
          </div>
        </div>

        <button
          onClick={() => navigate('/metronome')}
          style={{ width: '100%', padding: '13px', background: '#FF5500', borderRadius: 10, color: '#fff', fontFamily: "'Barlow Condensed'", fontWeight: 800, fontSize: 15, letterSpacing: 2, border: 'none', cursor: 'pointer', marginBottom: 12 }}>
          OPEN METRONOME
        </button>

        <button
          onClick={signOut}
          style={{ width: '100%', padding: '11px', background: 'transparent', borderRadius: 10, color: '#5A5650', fontFamily: "'Barlow Condensed'", fontWeight: 700, fontSize: 13, letterSpacing: 1, border: '1px solid #2A2520', cursor: 'pointer' }}>
          SIGN OUT
        </button>
      </div>

      <div style={{ marginTop: 24, fontSize: 11, color: '#2E2A26', letterSpacing: 2, fontWeight: 600, fontFamily: "'Barlow Condensed'" }}>DRUMNASIUM © 2025 · PERCUSSION TRAINING</div>
    </div>
  );
}
